/**
 * Top card that names the current step (title + subtitle) and reminds
 * the user that demos are for faculty members only. Re-renders cheaply
 * — no props besides `step`.
 */

import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import { COPY, STEP_TITLES, STEP_SUBTITLES } from "./demoRequestConstants";

export default function DemoFlowHeaderCard({ step }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  const title = STEP_TITLES[step - 1] || "";
  const subtitle = STEP_SUBTITLES[step - 1] || "";

  return (
    <Box sx={{ mb: 2.5 }}>
      <Box
        sx={{
          borderRadius: 3,
          border: `1px solid ${theme.palette.primary.main}44`,
          bgcolor: `${theme.palette.primary.main}${isDark ? "18" : "0C"}`,
          px: 2.5,
          py: 2,
          mb: 1.25,
        }}
      >
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: 18,
            color: "text.primary",
            mb: 0.5,
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            fontSize: 14,
            lineHeight: 1.55,
            color: "text.secondary",
          }}
        >
          {subtitle}
        </Typography>
      </Box>
      <Typography
        sx={{
          fontSize: 12,
          color: "text.secondary",
          textAlign: "center",
          px: 1,
        }}
      >
        {COPY.forProfessorsBanner}
      </Typography>
    </Box>
  );
}

DemoFlowHeaderCard.propTypes = {
  step: PropTypes.number.isRequired,
};
